// extracted by mini-css-extract-plugin
export default {"bar":"Stock_bar__IbOsL"};